import { styled } from 'styled-components';

import { colors, spacing, fontSizes } from '#/theme/theme';

export const QueryFieldButton = styled.button`
  display: flex;
  align-items: center;
  gap: ${spacing[8]};
  width: 100%;
  min-width: 0;
  height: 40px;
  padding: 0 ${spacing[12]};
  border: 1px solid ${colors.inputGrey};
  border-radius: 8px;
  background: ${colors.inputGrey};
  cursor: pointer;
  font-size: ${fontSizes[14]};
  color: ${colors.darkContentGrey};
  text-align: left;
  overflow: hidden;

  @media (hover: hover) {
    &:hover {
      border-color: ${colors.elementGrey};
    }
  }
`;

export const QueryFieldText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;

  &[data-is-placeholder='true'] {
    color: ${colors.mediumContentGrey};
  }
`;
